export default __webpack_public_path__ + "static/media/SG-Yellow-0000.526194ad.png";